<template>
  <div class="page-drawer">
    <slot name="drawer-content" />
  </div>
</template>

<style lang="less" scoped>
.page-drawer {
  background: @bg-default;
  height: 100%;
  width: 100%;
  max-width: 400px;
  min-width: 400px;
  border-right: 1px solid @stroke-default;
}
</style>
